import { useState } from 'react';
import Truncate from 'react-truncate-markup';

import Button from 'shared_DEPRECATED/components/Button';

import { Typography } from 'shared/components/Typography';

//TODO: create TextTruncate shared component 1204004602812536

type TJournalCardText = {
  text: string;
};

export const JournalCardText = ({ text }: TJournalCardText) => {
  const [isTruncated, setIsTruncated] = useState(true);
  const ReadMoreEllipsis = (
    <>
      ...
      <br />
      <Button onClick={() => setIsTruncated(false)}>
        <Typography
          color="blue"
          dataTestid="journal-sidebar-card-view-more-text-button"
        >
          View more
        </Typography>
      </Button>
    </>
  );

  return (
    <Typography
      type="meta"
      color="gray"
      whiteSpace="pre-wrap"
      wordBreak="break-word"
      dataTestid="journal-sidebar-card-text"
    >
      {isTruncated ? (
        <Truncate lines={3} ellipsis={ReadMoreEllipsis}>
          <span style={{ overflowWrap: 'anywhere' }}>{text}</span>
        </Truncate>
      ) : (
        <>
          <span style={{ overflowWrap: 'anywhere' }}>{text}</span>
          <br />
          <Button onClick={() => setIsTruncated(true)}>
            <Typography color="blue">View less</Typography>
          </Button>
        </>
      )}
    </Typography>
  );
};
